import React from "react";
import { Link } from "react-router-dom";

const LpFooter = () => {
  return (
    <footer className="bg-[#07382f] text-white py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 flex flex-col items-center text-center">
        <span className="font-heading text-xl font-extrabold tracking-tight text-white mb-6 block">
          Trademark Facility
        </span>

        <p className="text-gray-400 text-sm mb-8">
          &copy; {new Date().getFullYear()} Trademark Facility. All Rights
          Reserved.
        </p>

        <div className="flex items-center gap-6 text-sm text-gray-400">
          <Link
            to="privacy-policy"
            className="hover:text-white transition-colors duration-200"
          >
            Privacy Policy
          </Link>
          <Link
            to="terms-and-conditions"
            className="hover:text-white transition-colors duration-200"
          >
            Terms &amp; Conditions
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default LpFooter;
